var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConfig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_778_9208)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9.33333,
    cy: 14.6668,
    r: 9.33333,
    fill: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7271 3.53975L13.6479 1.12725C13.5625 1.09808 13.4479 1.0835 13.3333 1.0835C13.2188 1.0835 13.1042 1.09808 13.0188 1.12725L5.93958 3.53975C5.76667 3.59808 5.625 3.79808 5.625 3.98141V14.0314C5.625 14.2147 5.74375 14.4564 5.8875 14.571L13.0688 20.1668C13.1417 20.2231 13.2354 20.2522 13.3313 20.2522C13.4271 20.2522 13.5229 20.2231 13.5938 20.1668L20.775 14.571C20.9188 14.4585 21.0375 14.2168 21.0375 14.0314V3.98141C21.0417 3.79808 20.9 3.60016 20.7271 3.53975ZM19.5417 13.6314L13.3333 18.4689L7.125 13.6314V4.72308L13.3333 2.60641L19.5417 4.72308V13.6314ZM11.0604 11.0168L9.44583 12.6314C9.41482 12.6627 9.39742 12.705 9.39742 12.7491C9.39742 12.7932 9.41482 12.8355 9.44583 12.8668L10.1542 13.5752C10.2188 13.6397 10.325 13.6397 10.3896 13.5752L12.0042 11.9606C13.1646 12.6918 14.7146 12.5522 15.725 11.5418C16.8979 10.3689 16.8979 8.46891 15.725 7.296C14.5521 6.12308 12.6521 6.12308 11.4792 7.296C10.4688 8.30641 10.3292 9.8585 11.0604 11.0168ZM12.4229 8.23975C13.075 7.58766 14.1313 7.58766 14.7813 8.23975C15.4333 8.89183 15.4333 9.94808 14.7813 10.5981C14.1292 11.2502 13.0729 11.2502 12.4229 10.5981C11.7729 9.946 11.7708 8.89183 12.4229 8.23975Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_778_9208"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfig);
export default __webpack_public_path__ + "static/media/config.4f8c63d8952627c8fdd5e352d76b9c88.svg";
export { ForwardRef as ReactComponent };